/** Opciones reutilizables en filtros superiores y columnas de tabla. */
export const ANIO_ACTUAL = new Date().getFullYear();
export const ANIO_ANTERIOR = ANIO_ACTUAL - 1;

export const OPCIONES_ANIO = [
  { label: String(ANIO_ACTUAL), value: ANIO_ACTUAL },
  { label: String(ANIO_ANTERIOR), value: ANIO_ANTERIOR },
];

export const OPCIONES_MESES = [
  { label: 'Enero', value: '1' },
  { label: 'Febrero', value: '2' },
  { label: 'Marzo', value: '3' },
  { label: 'Abril', value: '4' },
  { label: 'Mayo', value: '5' },
  { label: 'Junio', value: '6' },
  { label: 'Julio', value: '7' },
  { label: 'Agosto', value: '8' },
  { label: 'Septiembre', value: '9' },
  { label: 'Octubre', value: '10' },
  { label: 'Noviembre', value: '11' },
  { label: 'Diciembre', value: '12' },
];

export const OPCIONES_REPORTO = [
  { label: 'Si', value: 'Si' },
  { label: 'No', value: 'No' },
];

export const OPCIONES_ESLABON = [
  { label: 'Productor', value: 'Productor' },
  { label: 'Importador', value: 'Importador' }
];

/** Filtros superiores → `[filters]` de `app-table`. */
export const REPORTE_CUMPLIMIENTO_FILTERS: unknown[] = [
];

/** Definición de columnas → `[columns]` de `app-table`. */
export const REPORTE_CUMPLIMIENTO_COLUMNS: unknown[] = [
  {
    campo: 'nit',
    label: 'NIT',
    tipoFiltro: 'alfanumerico',
  },
  {
    campo: 'razonSocial',
    label: 'Razón social',
    tipoFiltro: 'alfanumerico'
  },
  {
    campo: 'correoCorporativo',
    label: 'Correo corporativo',
    tipoFiltro: 'alfanumerico',
    width: '18%',
  },
  {
    campo: 'telefono',
    label: 'Teléfono',
    tipoFiltro: 'numerico',
  },
  {
    campo: 'eslabon',
    label: 'Eslabón',
    tipoFiltro: 'alfanumerico',
    className: 'col-2',
  },
  {
    campo: 'nombreRepresentante',
    label: 'Nombre representante',
    tipoFiltro: 'alfanumerico',
    width: '10%',
  },
  {
    campo: 'anioReporte',
    label: 'Año reporte',
    tipoFiltro: 'multiseleccion',
    options: OPCIONES_ANIO,
    valorInicial: String(ANIO_ACTUAL),
  },
  {
    campo: 'mesReporte',
    label: 'Mes reporte',
    tipoFiltro: 'multiseleccion',
    options: OPCIONES_MESES
  },
  {
    campo: 'productosReportados',
    label: 'Productos reportados',
    tipoFiltro: 'numerico',
  },
  {
    campo: 'reporto',
    label: 'Reportó',
    tipoFiltro: 'seleccion',
    options: OPCIONES_REPORTO
  },
];

/** Filas de ejemplo → `[data]` de `app-table` (reemplazar por respuesta del API). */
export const REPORTE_CUMPLIMIENTO_DATA: Record<string, unknown>[] = [
  {
    nit: '900123456-7',
    razonSocial: 'Agroinsumos del Campo SAS',
    correoCorporativo: 'contacto@agroinsumos.com',
    telefono: '6014567890',
    eslabon: 'Productor',
    nombreRepresentante: 'Carlos Martínez',
    anioReporte: 2026,
    mesReporte: 'Abril',
    reporto: 'Si',
  },
  {
    nit: '901987654-3',
    razonSocial: 'Importadora Agroverde LTDA',
    correoCorporativo: 'info@agroverde.com',
    telefono: '6043219876',
    eslabon: 'Importador',
    nombreRepresentante: 'Laura Gómez',
    anioReporte: 2026,
    mesReporte: 'Marzo',
    reporto: 'No',
  },
  {
    nit: '800456123-1',
    razonSocial: 'Fertilizantes Nacionales SAS',
    correoCorporativo: 'servicio@fertinacionales.com',
    telefono: '6057891234',
    eslabon: 'Productor',
    nombreRepresentante: 'Andrés Rojas',
    anioReporte: 2025,
    mesReporte: 'Diciembre',
    reporto: 'Si',
  },
  {
    nit: '900123456-7',
    razonSocial: 'Agroinsumos del Campo SAS',
    correoCorporativo: 'contacto@agroinsumos.com',
    telefono: '6014567890',
    eslabon: 'Productor',
    nombreRepresentante: 'Carlos Martínez',
    anioReporte: 2026,
    mesReporte: 'Abril',
    reporto: 'Si',
  },
];
